<template lang="pug">
div
  .text-md.font-semibold.mb-4 Documents
  .data-table
    v-data-table(:headers="headers" :items="documents" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" disable-sort)
      template(v-slot:item.number="{ index }")
        .text-xs.neutral500--text.font-bold {{ index+1 }}
      template(v-slot:item.product="{ item }")
        .text-sm.font-semibold {{ item.name }}
      template(v-slot:item.quantity="{ item }")
        .text-sm.font-normal {{ item.quantity }}
      template(v-slot:item.total="{ item }")
        .text-sm.font-normal {{ item.price | displayPrice }}
      
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    selectedHistory: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean
    }
  },
  data() {
    return {
      isFetching: false,
      open: true,
      checkAll: false,
      pageSize: -1,
      headers: [
        {
          text: '#',
          value: 'number',
          width: 25
        },
        {
          text: 'item',
          value: 'product',
          width: 350
        },
        {
          text: 'Qty',
          value: 'quantity',
        },
        {
          text: 'Total Price',
          value: 'total',
          width: 150
        }
      ],
      documents: [],
      selectedDocuments: []
    }
  },
  mounted () {
    this.headers.map(item => item['class'] = 'text-table-header')
    this.documents = this.selectedHistory.documents.map(document => this.filterDocumentData(document))
  },
  methods: {
    ...mapActions(['showMessage']),
    filterDocumentData(obj) {
      const allowedProperties = ['id', 'name', 'quantity', 'product', 'price', 'extra_data']
      const filteredObj = this.$options.filters.filterAllowedObjectProperties(obj, allowedProperties)
      return filteredObj
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
</style>